







import Vue from 'vue'
export default Vue.extend({
  props: {
    path: {
      type: String
    },
    fullPath: {
      type: String
    }
  },
  data() {
    return {
      seconds: 5
    }
  },
  methods: {
    redirectSecond() {
      if (this.seconds > 0) {
        setTimeout(() => {
          this.seconds = this.seconds - 1
          this.redirectSecond()
        }, 1000)
      } else {
        this.$router.push("/")
      }
    }
  },
  created() {
    if (!this.path) this.$router.push("/")
  },
  mounted() {
    this.redirectSecond()
  }
})
